import { oc } from "@orpc/contract";
import { z } from "zod";

const attachmentSchema = z.object({
  content: z.string(),
  filename: z.string(),
  type: z.string(),
});

export const trafficGeneratorContracts = {
  sendTrafficEmail: oc
    .input(
      z.object({
        recipientEmail: z.string().email(),
        subject: z.string(),
        textBody: z.string(),
        attachments: z.array(attachmentSchema).optional(),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
        outboundEmailId: z.string().optional(),
        error: z.string().optional(),
      }),
    )
    .route({
      summary: "Send a test traffic email",
      description:
        "Admin only. Sends one test email with optional attachments to an internal test address to exercise email-ingest workflows.",
      method: "POST",
    }),

  createScheduledEmail: oc
    .input(
      z.object({
        recipientEmail: z.string().email(),
        subject: z.string(),
        textBody: z.string(),
        attachments: z.array(attachmentSchema).optional(),
        intervalMinutes: z.number().int().positive(),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
        scheduledEmailId: z.string().optional(),
      }),
    )
    .route({
      summary: "Schedule a recurring test traffic email",
      description:
        "Admin only. Creates an active schedule that sends a test email to an internal test address every N minutes, starting immediately.",
      method: "POST",
    }),

  listScheduledEmails: oc
    .input(z.object({}))
    .output(
      z.object({
        items: z.array(
          z.object({
            id: z.string(),
            recipientEmail: z.string(),
            subject: z.string(),
            textBody: z.string(),
            intervalMinutes: z.number(),
            status: z.enum(["active", "paused"]),
            sendCount: z.number(),
            lastSentAt: z.string().nullable(),
            nextSendAt: z.string(),
            lastError: z.string().nullable(),
            createdByUserName: z.string(),
            createdAt: z.string(),
          }),
        ),
      }),
    )
    .route({
      summary: "List scheduled test traffic emails",
      description:
        "Admin only. Lists the organization's recurring test emails with recipient, interval, status, send count, last and next send, and last error.",
      method: "POST",
    }),

  updateScheduledEmailStatus: oc
    .input(
      z.object({
        id: z.string(),
        status: z.enum(["active", "paused"]),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
      }),
    )
    .route({
      summary: "Pause or resume a scheduled test email",
      description:
        "Admin only. Sets a recurring test email to active or paused; resuming schedules the next send immediately.",
      method: "POST",
    }),

  deleteScheduledEmail: oc
    .input(
      z.object({
        id: z.string(),
      }),
    )
    .output(
      z.object({
        success: z.boolean(),
      }),
    )
    .route({
      summary: "Delete a scheduled test traffic email",
      description:
        "Admin only. Permanently removes a recurring test email schedule from the organization.",
      method: "POST",
    }),
};
